module.exports = __webpack_public_path__ + "static/media/logo.5aa6474d.png";